import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { Loading } from '../components/Loading';
import { EmptyState } from '../components/EmptyState';

export function AdminModerationPage() {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);

  const fetchPosts = useCallback(async () => {
    setLoading(true);
    setMessage(null);
    try {
      const { data } = await api.get('/admin/feed');
      setPosts(data.data || []);
    } catch (err) {
      setMessage({ type: 'err', text: err.response?.data?.error?.message || 'Erro ao carregar publicações' });
      setPosts([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchPosts(); }, [fetchPosts]);

  const moderate = async (post, is_active) => {
    setMessage(null);
    try {
      await api.patch(`/admin/feed/${post.id}/moderate`, { is_active });
      setMessage({ type: 'ok', text: is_active ? 'Publicação reativada.' : 'Publicação ocultada do feed.' });
      fetchPosts();
    } catch (err) {
      setMessage({ type: 'err', text: err.response?.data?.error?.message || 'Erro na moderação.' });
    }
  };

  const typeLabel = (t) => ({ promocao: 'Promoção', evento: 'Evento', aviso: 'Aviso', novidade: 'Novidade', emprego: 'Emprego', achado: 'Achado', perdido: 'Perdido' }[t] || t);

  return (
    <div className="nc-page">
      <div className="nc-pagehead">
        <div className="nc-row">
          <button onClick={() => navigate('/admin')} aria-label="Voltar" className="nc-iconbtn">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5" /><path d="M12 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="nc-page-title">Moderação do feed</h1>
        </div>
      </div>

      <div style={{ padding: 16 }}>
        {message && (
          <div role="status" style={{
            padding: '10px 12px', borderRadius: 8, marginBottom: 12, fontSize: 13,
            background: message.type === 'ok' ? '#f0fdf4' : '#fef2f2',
            border: `1px solid ${message.type === 'ok' ? '#bbf7d0' : '#fecaca'}`,
            color: message.type === 'ok' ? '#15803d' : '#b91c1c'
          }}>
            {message.text}
          </div>
        )}

        {loading ? <Loading /> : posts.length === 0 ? (
          <EmptyState icon="📢" title="Sem publicações" description="O feed ainda não tem publicações." />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {posts.map(p => (
              <div key={p.id} style={{
                background: 'var(--nc-surface)', borderRadius: 12, border: '1px solid var(--nc-border)',
                padding: 14, opacity: p.is_active ? 1 : 0.6
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
                  <span style={{
                    fontSize: 10, fontWeight: 600, color: 'var(--nc-on-primary)', background: 'var(--nc-primary)',
                    padding: '2px 8px', borderRadius: 10
                  }}>{typeLabel(p.type)}</span>
                  <span className="nc-caption">
                    {p.city_name || '—'} {p.author_name ? `• ${p.author_name}` : ''}
                    {p.business_name ? ` • ${p.business_name}` : ''}
                  </span>
                  {!p.is_active && (
                    <span style={{ fontSize: 10, fontWeight: 600, color: 'var(--nc-danger-text)', background: 'var(--nc-danger-soft)', padding: '2px 8px', borderRadius: 10, marginLeft: 'auto' }}>
                      OCULTA
                    </span>
                  )}
                </div>
                {p.title && <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--nc-text)', marginBottom: 2 }}>{p.title}</div>}
                <div style={{ fontSize: 13, color: 'var(--nc-text-dim)', marginBottom: 10 }}>{p.content}</div>
                {/* LE-037 (auditoria): quem/ quando moderou por último — rótulo
                    "Última moderação" (não confunde com o estado OCULTA) */}
                {p.moderated_at && (
                  <div className="nc-caption" style={{ marginBottom: 10 }}>
                    🛡️ Última moderação: {p.moderated_by_name || '—'} em {new Date(p.moderated_at).toLocaleString('pt-BR')}
                  </div>
                )}
                <div style={{ display: 'flex', gap: 8 }}>
                  <button
                    onClick={() => moderate(p, !p.is_active)}
                    style={{
                      flex: 1, padding: '9px 0', borderRadius: 8, border: '1px solid var(--nc-border)',
                      background: 'var(--nc-surface)', fontSize: 13, fontWeight: 500, cursor: 'pointer',
                      color: p.is_active ? '#b91c1c' : '#0d5c3b'
                    }}
                  >
                    {p.is_active ? 'Ocultar do feed' : 'Reativar publicação'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
